

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalserviceService } from 'src/app/helpers/services/localservice.service';
import { Constant } from 'src/app/helpers/constants/constant';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SharedAlertModelComponent } from 'src/app/common-shared-modules/shared-alert-model/shared-alert-model.component';
import { AlertSwipeComponent } from 'src/app/common-shared-modules/alert-swipe/alert-swipe.component';


@Component({
  selector: 'app-group-renewal-login',
  templateUrl: './group-renewal-login.component.html',
  styleUrls: ['./group-renewal-login.component.css']
})
export class GroupRenewalLoginComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  auth = {
    policynumber: '',
    dob: '',
    txtMobileNumber: ''
  };


  // private alertSwipe =new AlertSwipeComponent()
  @ViewChild(AlertSwipeComponent) private alertSwipe:
    AlertSwipeComponent;
  messageObj: any;


  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public appservice: LocalserviceService,
    public matDialog: MatDialog,
  ) {

  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      policyNo: ['', Validators.required],
      dob: ['', Validators.required],
      txtMobileNumber: ['', Validators.required]


    });

    delete sessionStorage.refNoArray;

    if (this.appservice.subsVar == undefined) {
      this.appservice.subsVar = this.appservice.
        invokeParenComponentFunction.subscribe((name: string) => {
          //alert(name)
        });
    }

  }


  changeField() {
    if (this.form.value.policyNo != '' && (this.form.value.txtMobileNumber == '' || this.form.value.txtMobileNumber == undefined)) {
      this.form.controls.txtMobileNumber.disable();
      this.form.controls.dob.enable();
    }
    if (this.form.value.policyNo != '' && (this.form.value.dob == '' || this.form.value.dob == undefined)) {
      this.form.controls.dob.disable();
      this.form.controls.txtMobileNumber.enable();
    }
  }
  /* ----------------------to validate for check login------------------------- */
  onSubmit(auth, form) {
    console.log(this.alertSwipe);
    var pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
    var DOBpattern = (form.value.dob == "" || form.value.dob == undefined) ? true : (pattern.test(form.value.dob));
    if (DOBpattern == false) {
      this.messageObj = {
        "messageVal": "Please enter correct dob",
        "classVal": "e",
        "showAlertSwipe": true
      }

      this.alertSwipe.sliderAlertSwipe(this.messageObj)

    } else
      var mobilePattern = /^[6789]\d{9}$/;
    var mobileNoPattern = (form.value.txtMobileNumber == "" || form.value.txtMobileNumber == undefined) ? true : (mobilePattern.test(form.value.txtMobileNumber));
    if (mobileNoPattern == false) {
      this.messageObj = {
        "messageVal": "Please enter valid mobile number.",
        "classVal": "e",
        "showAlertSwipe": true
      }
      this.alertSwipe.sliderAlertSwipe(this.messageObj)
    } else {
      if (!form.value.dob && !form.value.txtMobileNumber) {
        const alertModel = new MatDialogConfig();
        alertModel.disableClose = true;
        alertModel.id = "modal-component";
        alertModel.height = "195px";
        alertModel.width = "550px";
        alertModel.data = {
          title: "Insufficient details",
          description: "Please provide atleast 2 details.",
          successText: "OK",
          failureText: "cancel",
          showSuccessBtn: true,
          showFaliureBtn: false,

        }
        const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
      } else {

        var subDate = this.auth.dob.split('/');

        var subDate1;

        if (((subDate[0]) == undefined || subDate[0] == null) || (subDate[1] == undefined || subDate[1] == null) || (subDate[2] == undefined || subDate[2] == null)) {
          subDate1 = "";
        } else {
          subDate1 = subDate[1] + "/" + subDate[0] + "/" + subDate[2];
        }
        const headernew = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Access-Control-Allow-Headers': 'Content-Type',
          //'x-ob-bypass': Constant.x_ob_bypass,
          'x-ob-at': Constant.x_ob_at,
          'x-ob-ut': '',
        };
        var loginObj = {
          "LeadID": "",
          "MasterPolicyNumber": "",
          "CertificateNumber": this.auth.policynumber,
          "DOB": (subDate1 == undefined || subDate1 == null) ? "" : subDate1,
          "ProposerMobileNumber": this.auth.txtMobileNumber
        }

        this.appservice.show()
        this.appservice.PostApi(Constant.hpre_BaseUrl + '/api/groupRenew/CheckRenewDetails', loginObj, headernew).subscribe(res => {
          console.log(res)
          this.appservice.hide()
          if (res.ResponseCode == '1') {
            var policyDetails = res.ResponseData;
            if ((policyDetails.ErrorMessage != "" || policyDetails.ErrorMessage != undefined) && policyDetails.ErrorMessage != "Success.") {
              const alertModel = new MatDialogConfig();
              alertModel.disableClose = true;
              alertModel.id = "modal-component";
              alertModel.height = "195px";
              alertModel.width = "550px";
              alertModel.data = {
                title: "Alert",
                description: policyDetails.ErrorMessage,
                successText: "OK",
                failureText: "cancel",
                showSuccessBtn: true,
                showFaliureBtn: true,

              }
              const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
            } else {
              sessionStorage.refNoArray = JSON.stringify(policyDetails.Policies);
              console.log(sessionStorage.refNoArray);
              sessionStorage.setItem('ut', policyDetails.Policies[0].ut);
              window.location.href = 'group-renew-landing';
            }
            this.auth.policynumber = "";
            this.auth.dob = "";
            this.auth.txtMobileNumber = "";
          } else if (res.ResponseCode == '0') {
            var errorMessage = res.ResponseData != null ? res.ResponseData.ErrorMessage : res.ResponseMessage
            const alertModel = new MatDialogConfig();
            alertModel.disableClose = true;
            alertModel.id = "modal-component";
            alertModel.height = "195px";
            alertModel.width = "550px";
            alertModel.data = {
              title: "Alert",
              description: errorMessage,
              successText: "OK",
              failureText: "cancel",
              showSuccessBtn: true,
              showFaliureBtn: true,

            }
            // window.location.href = 'group-renew-landing'
            const modalDialog = this.matDialog.open(SharedAlertModelComponent, alertModel);
          }

        })

      }

    }
  }
  /*-----------------------to validate form and check login--------------------*/
  onSuccess() {

  }

}

